'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataIterator: {
        rowsPerPageText: 'Items per page:',
        rowsPerPageAll: 'All',
        pageText: '{0}-{1} of {2}',
        noResultsText: 'No matching records found',
        nextPage: 'Next page',
        prevPage: 'Previous page'
    },
    dataTable: {
        rowsPerPageText: 'Rows per page:'
    },
    noDataText: 'No data available',
    carousel: {
        prev: 'Previous visual',
        next: 'Next visual'
    }
};
//# sourceMappingURL=en.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/locale/en.js
// module id = 542
// module chunks = 0